// extracted by mini-css-extract-plugin
export default {"avatarContainer":"Avatar_avatarContainer__5QA2Y","textAvatar":"Avatar_textAvatar__0TXJd","avatar":"Avatar_avatar__qbz0B","hide":"Avatar_hide__yJy+u"};